export default __webpack_public_path__ + "static/media/rocket_anim_86.5620bddf.png";